import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, projectname, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import LOADER from "../../assets/img/barakahhijama.gif";

function GenderList() {
  const loaderCss = css`
    margin: auto;
  `;
  const con = {
    headers: {
      ContentType: 'application/json',
      Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
    },
  };
  const history = useHistory();
  const [tags, setTags] = useState([]);
  const [loading, setloading] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getTags();
    const interval = setInterval(() => {
      getTags();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getTags = () => {
    axios.get(URL_API + "auth/admin/gender", con).then((response) => {
      if (response.data.status === 200) {
        setTags(response.data.categories);
        setloading(false)
      }
    });
  };

  const destroyTag = (id) => {
    axios
      .post(URL_API + `auth/admin/gender-delete/${id}`, '', con)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/genders");
          toast.success("Category Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getTags();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  {projectname} | <i class="fa fa-home" aria-hidden="true"></i> |
                  Genders
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/gender/create`}>
                  <strong>Add Gender + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>

                  {loading == true ? (
                    <>
                      <div className="loader">
                        <img src={LOADER} />
                      </div>
                    </>

                  ) : (<>
                    <thead className="text-primary">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Created At</th>
                        <th>Action</th>
                        {/* <th className="text-right">Salary</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {tags.map(
                        (tag, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{tag?.title}</td>
                              <td>
                                {moment(tag?.created_at).format(" DD MMMM,YYYY")}
                              </td>
                              <td>
                                {/* <a style={{color:"#77ac54"}} href={`article/detail/${tag.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                                <Link to={`gender/edit/${tag.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a
                                  style={{ color: "red" }}
                                  onClick={() => destroyTag(tag.id)}
                                >
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        }
                        // )
                      )}

                    </tbody>
                  </>)}

                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default GenderList;
